require('./ctxTagsEnter.style.scss');

const KEY_CODES = {
  ENTER: 13,
  SPACE: 32,
  BACKSPACE: 8
};

class ctxTagsEnterController {

    constructor($scope, $element, $filter) {
        this.$scope = $scope;
        this.$element = $element;
        this.$filter = $filter;
        this.outputData = [];
    }

    $onInit() {
        if(this.value.length > 0) this.outputData = this.value;
        if(this.isRequired)
            this.$scope.$watchCollection(() => this.value, value => this.form[this.inputName].$setValidity('custom', value.length > 0));
        this.$scope.$watch(() => this.inputTag, () => {
            this.form[this.inputName].$setValidity('unique', this.isUnique());
            this.inUse = this.inputTag || this.form[this.inputName].$invalid;
        });
    }


    isUnique() {
        this.isTagUnique = !this.outputData.length || !this.outputData.filter(item => item === this.inputTag).length;
        if(!this.isTagUnique) this.uniqueMessage = this.$filter('translate')('ctxTagsEnter.validation.unique', {value: this.inputTag});
        return this.isTagUnique;
    }

    showTag(event) {
        if(event.keyCode === KEY_CODES.SPACE) {
            if(this.form[this.inputName].$valid && (this.inputTag === null || this.inputTag === undefined || this.inputTag === '')) {
                return;
            }
            event.stopPropagation();
            this.saveInfo(true);
        }
        else if(event.keyCode === KEY_CODES.BACKSPACE) {
            if(this.form[this.inputName].$valid && this.inputTag === undefined) this.inputTag = null;
            if(this.inputTag === null) {
                event.stopPropagation();
                this.removeTag(null);
            } else if(this.inputTag === '') {
                this.inputTag = null;
            }
        }
    }

    onFocusAction() {
        this.inUse = this.inputTag || this.form[this.inputName].$invalid;
    }

    onBlurAction() {
        this.saveInfo();
        this.inUse = false;
    }

    saveInfo(onEnter) {
        if(!this.inputTag || !this.isTagUnique) {
            if(onEnter && this.form[this.inputName] && !this.form[this.inputName].$touched) this.form[this.inputName].$touched = true;
            return;
        }
        this.outputData.push(this.inputTag);
        this.value = this.outputData;
        this.inputTag = null;
    }

    focusInput() {
        this.$element.find('.enter-input').focus();
    }

    removeTag($index) {
        ($index === null) ? this.outputData.pop() : this.outputData.splice($index, 1);
        this.value = this.outputData;
    }

    isTouched() {
        return this.form && this.form[this.inputName].$touched;
    }

    isFormSubmitted() {
        return this.form && this.form.$submitted;
    }

    isTouchedOrSubmitted() {
        return this.isFormSubmitted() || this.isTouched();
    }

    hasErrorsFlags() {
        return (this.form[this.inputName].$error.custom) ||
               (this.form[this.inputName].$error.pattern) ||
               (this.form[this.inputName].$error.minlength) ||
               (this.form[this.inputName].$error.maxlength);
    }

    hasErrors() {
        return this.isTouchedOrSubmitted() && this.hasErrorsFlags();
    }

    isValid() {
        if(angular.isUndefined(this.form)) return;
        return this.form[this.inputName].$dirty && this.form[this.inputName].$valid;
    }

}

ctxTagsEnterController.$inject = ['$scope', '$element', '$filter'];

const ctxTagsEnterComponent = {
    controller: ctxTagsEnterController,
    template: require('./ctxTagsEnter.template.html'),
    scope: {},
    bindings: {
        inputName: '@',
        inputLabel: '@?',
        inputType: '@?',
        placeholder: '@?',
        form: '<',
        validatePattern: '=?',
        patternMessage: '@?',
        maxLength: '@?',
        minLength: '@?',
        value: '=',
        isRequired: '<?',
        inUse: '=?',
        customWarning: '<?'
    }
};

module.exports = ctxTagsEnterComponent;


// WEBPACK FOOTER //
// ./src/shared/ctxTagsEnter/ctxTagsEnter.component.js